export enum ECouponStatus {
  NONEXISTENT = 'NONEXISTENT',
  EXPIRED = 'EXPIRED',
  AVAILABLE = 'AVAILABLE',
}
